import { useState } from "react";
import { Check } from "lucide-react";
import { toast } from "sonner";
import { api, useSubmit } from "@/lib/api";
import { ErrorBox, Field, Modal } from "@/components/common";

const EMPTY = { name: "", phone: "", age: "", gender: "", address: "", medical_history: "", allergies: "", notes: "" };

export default function PatientForm({ patient, onClose, onSaved }) {
  const [form, setForm] = useState(patient ? { ...EMPTY, ...patient } : EMPTY);
  const { busy, error, run } = useSubmit();
  const set = (k) => (v) => setForm({ ...form, [k]: v });
  const save = () => run(async () => {
    const body = Object.fromEntries(Object.keys(EMPTY).map((k) => [k, form[k] || ""]));
    const r = patient ? await api.patch(`/patients/${patient.id}`, body) : await api.post("/patients", body);
    toast.success(patient ? "Patient updated" : `Patient added as ${r.data.opd}`);
    onSaved(r.data);
  });
  return (
    <Modal eyebrow="PATIENT REGISTER" title={patient ? "Edit patient" : "Add patient"} onClose={onClose} onSubmit={save} testid="patient-form">
      <Field label="Full name" testid="patient-name-input" required value={form.name} onChange={set("name")} />
      <div className="form-two">
        <Field label="Phone" testid="patient-phone-input" value={form.phone} onChange={set("phone")} />
        <Field label="Age" testid="patient-age-input" value={form.age} onChange={set("age")} />
      </div>
      <div className="form-two">
        <Field label="Gender" testid="patient-gender-select" value={form.gender} onChange={set("gender")} options={[{ value: "", label: "—" }, "Female", "Male", "Other"]} />
        <Field label="Allergies" testid="patient-allergies-input" value={form.allergies} onChange={set("allergies")} />
      </div>
      <Field label="Address" testid="patient-address-input" value={form.address} onChange={set("address")} />
      <Field label="Medical history" testid="patient-history-input" textarea value={form.medical_history} onChange={set("medical_history")} />
      <Field label="Notes" testid="patient-notes-input" textarea value={form.notes} onChange={set("notes")} />
      <ErrorBox error={error} testid="patient-form-error" />
      <button className="primary full" disabled={busy} data-testid="save-patient-button"><Check size={17} /> {busy ? "Saving…" : "Save patient"}</button>
    </Modal>
  );
}
